import React from 'react';

function DarkFaqAccess(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      width={52}
      height={52}
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect width={52} height={52} rx={4} fill='#5B316D' />
      <mask
        id='mask0_10148_43174'
        style={{
          maskType: 'alpha'
        }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={10}
        width={32}
        height={32}
      >
        <rect x={10} y={10} width={32} height={32} fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_10148_43174)'>
        <path
          d='M25.999 12C30.8523 12.0001 33.3182 16.0352 33.3184 18.6465V22.502H34.4883C35.5485 22.4611 36.9724 23.4701 36.9727 24.877L36.999 37.7031C36.9441 38.6198 36.1041 39.8606 34.6025 40H17.3271C16.2286 39.8876 15.1344 38.963 15 37.6982V24.9805C15 23.6347 16.2947 22.502 17.4023 22.502H18.6729V18.6465C18.6731 15.9862 21.1456 12 25.999 12ZM25.8779 27.1562C24.3682 27.2221 23.2703 28.6426 23.6289 30.0371C23.8006 30.7048 24.2508 31.1375 24.792 31.5469C24.792 32.4226 24.8008 33.3286 24.8008 34.2686C24.8008 35.6596 27.2051 35.6472 27.2051 34.2686C27.2051 33.3301 27.2139 32.4474 27.2139 31.5469C27.5739 31.2428 27.8864 31.0332 28.126 30.6182C29.0512 29.0125 27.7894 27.073 25.8779 27.1562ZM26.002 14.333C22.937 14.333 21.1445 16.7004 21.1445 18.6797V22.5029H30.8584L30.8594 22.502V18.6953C30.8591 16.7168 29.0667 14.333 26.002 14.333Z'
          fill='#C299C5'
        />
      </g>
    </svg>
  );
}

DarkFaqAccess.displayName = 'DarkFaqAccess';

export default DarkFaqAccess;
